import React from 'react';
import DndStatistics from './statisticDnd/Statistics';
import FbStatistics from './statisticFb/Statistics';
import FhbfStatistics from './statisticFhbf/Statistics';

const reactAppVersion = process.env.REACT_APP_VERSION;

function Statistics() {
  if (reactAppVersion === 'dnd') {
    return <DndStatistics filterStartYear={2022} />;
  }
  if (reactAppVersion === 'fb') {
    return <FbStatistics filterStartYear={2022} />;
  }
  if (reactAppVersion === 'fhbf') {
    return <FhbfStatistics filterStartYear={2024} />;
  }
  return <></>;
}

export default Statistics;
